import { HOURS_COUNT } from '@contexts/scheduler/constants';

export const GRID_TEMPLATE_COLUMNS = { gridTemplateColumns: `repeat(${HOURS_COUNT + 1}, 1fr)` };
